import { render, staticRenderFns } from "./add-one-candidate-new.vue?vue&type=template&id=6340bce2&scoped=true"
import script from "./add-one-candidate-new.vue?vue&type=script&lang=ts"
export * from "./add-one-candidate-new.vue?vue&type=script&lang=ts"
import style0 from "./add-one-candidate-new.vue?vue&type=style&index=0&id=6340bce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340bce2",
  null
  
)

export default component.exports